class validate{
    constructor(datNum){
        if (datNum === undefined) datNum = "phone";
        if (document.getElementById(datNum))
            this.teclaNumeros(datNum);
    }
    // validar telefono
    telephone(dato) {
        var datos = {};
        datos.error = false;
        datos.msj = '';

        if (dato == '') {
            datos.error = true;
            datos.msj = 'El teléfono es obligatorio';
        } else if (!(/^([0-9]{10,10})/.test(dato))) {
            datos.error = true;
            datos.msj = 'El teléfono debe tener 10 números';
        } else if ((/([0-9])\1{6,}/.test(dato))) {
            datos.error = true;
            datos.msj = 'El teléfono tiene más de 6 números repetidos consecutivamente';
        }
        else if (this.isConsecutivo(dato)) {
            datos.error = true;
            datos.msj = 'El Teléfono tiene más de 5 números consecutivos';
        } else if (this.isConsecutivoDesc(dato)) {
            datos.error = true;
            datos.msj = 'El teléfono tiene más de 5 números consecutivos desendentes';
        }
        return datos;
    }

    //VALIDA CODIGO
    codigo(dato){
        var datos = {};
        datos.error = false;
        datos.msj = '';

        if (dato == '') {
            datos.error = true;
            datos.msj = 'El código es obligatorio';
        } else if (!(/^([/0-9a-zA-ZñÑ_-]{10})/.test(dato))) {
            datos.error = true;
            datos.msj = 'El código debe tener 10 letras o numeros';
        } 

        return datos;
    }

    //validar email
    email(dato) {
        var datos = {};
        datos.error = false;
        datos.msj = '';
        var n = dato.search("@");
        var mail = dato.slice(0, n);
        if (dato == '') {
            datos.error = true;
            datos.msj = 'El correo es obligatorio';
        } else if (!(/^([a-zA-Z0-9_\.\-]{1,})+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9])+$/.test(dato)) || !(/^(?=.*[a-zA-Z])(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))$/.test(mail))) {
            datos.error = true;
            datos.msj = 'El correo tiene un formato inválido';
        }

        return datos;
    }

    teclaNumeros(dat) {
        document.getElementById(dat).addEventListener("keypress", (e) => {
            if (!this.soloNumeros(e))
                e.preventDefault();
        })
    }

    isConsecutivo(tel) {
        var flag = 0;
        for (var i = 1; i < tel.length; i++) {
            var chk = (parseInt(tel[i]) - 1) != tel[i - 1];
            if (!chk) {
                flag++;
                if (flag > 4)
                    return true;
            } else
                flag = 0;
        }

        return false;
    }

    // numeros consecutivos
    isConsecutivoDesc(tel) {
        var flag = 0;
        for (var i = 1; i < tel.length; i++) {
            var chk = (parseInt(tel[i]) + 1) != tel[i - 1];
            if (!chk) {
                flag++;
                if (flag > 4)
                    return true;
            } else
                flag = 0;
        }

        return false;
    }

    //VALIDACION SOLO NUMEROS 
    soloNumeros(e) {
        let key = e.keyCode || e.which;
        let tecla = String.fromCharCode(key).toLowerCase();
        let letras = "1234567890"; // letras permitidas
        let especiales = [46, 10, 13, 9, 8]; // carácteres especiales como espacio, borrar y enter
        let tecla_especial = false;
        for (let i in especiales) {
            if (key == especiales[i]) {
                tecla_especial = true;
                break;
            }
        }

        if (letras.indexOf(tecla) == -1 && !tecla_especial) {
            return false;
        }
        return true;
    }

    // poner, cada 3 numeros
    numeros(nuevoNumero) {
        // Ponemos un punto cada 3 caracteres
        let resultado = "";
        nuevoNumero = String(nuevoNumero);
        for (var j, i = nuevoNumero.length - 1, j = 0; i >= 0; i--, j++) {
            resultado = nuevoNumero.charAt(i) + ((j > 0) && (j % 3 == 0) ? "," : "") + resultado;
        }
        return (resultado);
    }

    //validar nombre
    nombres(dato){
		var datos = {};
		datos.error = false;
		datos.msj = '';
		if(dato == ''){
			datos.error = true;
			datos.msj = 'El nombre es obligatorio';
		}else if(!(/^([a-zA-Z+\Á+\É+\Í+\Ó+\Ú+\Ñ+\á+\é+\í+\ó+\ú+\ñ]{2,20})/.test(dato))){
			datos.error = true;
			datos.msj = 'El nombre debe contener almenos 2 letras';
		}else if(/(.)\1{3,50}/.test(dato)){
			datos.error = true;
			datos.msj = 'El nombre tiene 3 letras repetidas';
		}
        return datos;
    }
    
    //validar requerido
    requiere(dato) {
        var datos = {};
        datos.error = false;
        datos.msj = '';
        if (dato == '') {
            datos.error = true;
            datos.msj = 'El campo es obligatorio';
        }
        else if (!(/^([a-zA-Z0-9_\.\-\, +\Á+\É+\Í+\Ó+\Ú+\Ñ+\á+\é+\í+\ó+\ú+\ñ+1-]{4,600})/.test(dato))) {
            datos.error = true;
            datos.msj = 'El campo debe contener almenos 4 letras';
        }
        return datos;
    }
}

export default validate;


// WEBPACK FOOTER //
// ./resources/assets/js/lib/validate.js